<template>
	<div class="plugins-delivery-container">
		<CardSlashed v-if="userStore?.bannersData && !userStore?.bannersData?.has_delivery_orders" class="card-info-banner">
			<template #left>
				<div class="card-info-banner-title">
					<h2>{{ getString('card_info_title_1_delivery') }}</h2>
					<p>{{ getString('card_info_description_1_delivery') }}</p>
					<a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/articles/202000100944-delivery" class="icon-link">
						{{ getString('card_info_cta_1_delivery') }}
						<div class="wrapper-icon">
							<img src="https://img.qromo.io/img/icon-arrow-link-banner-geen.svg" alt="console icon">
						</div>
					</a>
				</div>
			</template>
			<template #right>
				<div class="wrapper-img">
					<picture>
						<source type="image/webp" srcset="https://img.qromo.io/img/image-info-banner-delivery.webp">
						<img src="https://img.qromo.io/img/image-info-banner-delivery.png" alt="product image">
					</picture>
				</div>
			</template>
		</CardSlashed>
		<DeliveryStatusCard @save-status="clickSaveStatus" />
		<DeliverySettingsCard @save-settings="clickSaveSettings"/>
	</div>
</template>

<script>
import DeliveryStatusCard from "@/console-new/components/plugins/DeliveryStatusCard.vue";
import DeliverySettingsCard from "@/console-new/components/plugins/DeliverySettingsCard.vue";

import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore}
	},
	name: "PluginsDelivery",
	components: {CardSlashed, DeliveryStatusCard, DeliverySettingsCard},
	data() {
		return {

		}
	},
	methods: {
		clickSaveStatus() {
			if(this.userStore.currBusiness.delivery && (!this.userStore.currBusiness.address_id || this.userStore.currBusiness.company_email.length <= 5 || !this.userStore.currBusiness.company_phone || this.userStore.currBusiness.company_phone.length <= 5)) {
				this.showNotification('delivery-status-no-phone');
				this.userStore.shouldOpenFiscal = true;
				this.$router.push("/config/settings/general");
				this.userStore.currBusiness.delivery = false;
				return;
			}
			this.userStore.updateDeliveryStatus((success, details)=>{
				if(success) {
					this.showNotification('delivery-status-updated');
				} else {
					let errorKey = details === 'no_address' ? 'delivery-status-no-address' : 'generic-fail';
					this.showNotification(errorKey);
				}
			});
		},
		clickSaveSettings() {

			this.userStore.updateDeliveryCouriers((success) => {
				if(success) {
					this.userStore.updateDeliveryCash((success, details) => {
						if(success) {
							let updateData = {
								delivery_courier: this.userStore.currBusiness.delivery_courier,
								delivery_distance: this.userStore.currBusiness.delivery_distance,
								delivery_costs: this.userStore.currBusiness.delivery_costs,
								delivery_min_order: this.userStore.currBusiness.delivery_min_order,
								delivery_future_days: this.userStore.currBusiness.delivery_future_days,
								delivery_courier_free_shipping: this.userStore.currBusiness.delivery_courier_free_shipping,
								delivery_courier_pickup_delay: this.userStore.currBusiness.delivery_courier_pickup_delay,
							}
							this.userStore.updateBusiness(updateData, success=>{
								this.showNotification(success ? "generic-success" : "generic-fail");
							})
						} else {
							this.showNotification(details === "not_subscribed" ? "payments-fail" : "generic-fail");
						}
					});
				} else {
					this.showNotification("generic-fail");
				}
			});

		},
	},
	created() {
		this.userStore.getDeliveryCouriers();
        
		if (!this.userStore.bannersData?.has_delivery_orders) {
			this.userStore.fetchBannersData('has_delivery_orders');
		}
	},
	watch: {
		'userStore.currBusinessId': {
			handler(newVal, oldVal) {
				if(newVal && newVal !== oldVal) {
					this.userStore.getDeliveryCouriers();
					this.userStore.fetchBannersData('has_delivery_orders');
				}
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.plugins-delivery-container {

	max-width: 1400px;
	margin: 0 auto;
	:deep(.card-container .card-body) {
		padding: 0;
		& > .list-container {
			.list-item:first-child::before {
				display: none;
			}

			.list-item:last-child::after {
				display: none;
			}
		}
	}
	.card-info-banner {
		margin-bottom: 40px;
		.card-info-banner-title {
			width: 100%;
			height: fit-content;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-direction: column;
			color: var(--color-txt-white);
			max-width: 400px;
			text-align: left;
			.align-text {
				display:flex;
				flex-direction: column;
			}
			&.divider {
				padding-bottom: 20px;
				border-bottom: 1px solid rgba(255, 255, 255, 0.5);
				width: 100%;
				margin-bottom: 20px;
			}
			h2 {
				font-size: 22px;
				display: inline-block;
				color: var(--color-txt-white);
				@media (max-width: 550px) {
					font-size: 20px;
					line-height: normal;
				}
			}
			p {
				font-size: 16px;
				line-height: 22px;
				color: var(--color-txt-white);
				margin-top: 10px;
				@media (max-width: 550px) {
					font-size: 14px;
					line-height: 20px;
				}
				&.br {
					margin-top: 15px!important;
				}
			}
			.card-info-banner-button {
				margin-top: 20px;
			}
		}
		&:deep(.slashed-card-container) {
			padding: 15px 20px;
			background: linear-gradient(204deg, #03C6F3 10%, rgb(47, 36, 209) 90%);
			height: 100%;
			gap: 40px;
			position: relative;
			.slashed-left {
				width: calc(65% - 20px);
				justify-content: flex-start;
				padding: 0;
				overflow: unset;
				border-radius: 0;
				flex-direction: column;
				z-index: 2;

				.card-info-banner-title {
					width: 100%;
					max-width: unset;
				}

				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
					min-height: unset;
					.card-info-banner-title {
						width: 100%;
						max-width: unset;
						padding: 0;
					}
				}
			}
			.slashed-right {
				z-index: 2;
				width: calc(35% - 20px);
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				@media (max-width: 550px) {
					width: 100%;
					padding: 0;
				}
			}
			@media (max-width: 550px) {
				flex-direction: column-reverse;
				gap: 0;
			}
		}
		.wrapper-img {
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			picture {
				img {
					width: 100%;
					height: 100%;
					max-height: 250px;
					object-fit: contain;
					@media (max-width: 550px) {
						max-height: 200px;
					}
				}
			}
		}
		.icon-link {
			min-height: 40px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			gap: 7px;
			margin-top: 8px;
			opacity: .9;
			transition: opacity .2s $transition;
			padding-right: 20px;
			font-size: 14px;
			line-height: 14px;
			font-weight: 400;
			color: var(--color-secondary);
			font-style: italic;
			width: calc(100% - 20px);
			&:after {
				display: none;
			}
			.wrapper-icon {
				margin-top: 2px;
				width: 12px;
				height: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: transform .2s $transition;
				transform: translateX(0);
				img {
					width: 100%;
					height: 100%;
					max-height: 180px;
					object-fit: contain;
				}
			}
			&:hover {
				opacity: 1;
				.wrapper-icon {
					transform: translateX(2px);
				}
			}
		}
	}
}
</style>